import { Component, Inject } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  NDVIChartComponent,
  NDVIDataPoint,
} from '../ndvi-chart/ndvi-chart.component';

export interface NDVIDialogData {
  data: NDVIDataPoint[];
  id?: number;
  cultura?: string | null;
  cropYear?: string | null;
  statusCulture?: string | null;
  areaTalhaoHa?: number;
  title?: string;
}

@Component({
  selector: 'app-ndvi-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NDVIChartComponent,
  ],
  templateUrl: './ndvi-dialog.component.html',
  styleUrls: ['./ndvi-dialog.component.scss'],
})
export class NDVIDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NDVIDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NDVIDialogData,
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
